export const CONST_SUCCESS_RESPONSE = "SUCCESS";